module.exports = __webpack_public_path__ + "static/media/AL.43493b49.svg";